import styled from 'styled-components/macro'

const ListWrapper = styled('div')`
  margin-top: 24px;
  width: 100%;
`

export default ListWrapper
